let sessionId: { id: string };
let initialized = false;

export const initSession = async (): Promise<{ id: string }> => {
  if (initialized && sessionId) return sessionId;
  const { VITE_BASE_API_URL } = import.meta.env;

  const res: Response = await fetch(`${VITE_BASE_API_URL}/session`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      traceparent: '8bdf037f-6e84-495d-b7b6-1454679501c2',
      'x-date-override': '2025-11-18T14:36:28.100Z',
      'x-interaction-id': 'e0d258b0-ea59-4b4a-ad83-6cd71f8778b0',
      'x-recaptcha-token': 'some-token',
    },
  });

  sessionId = await res.json();
  initialized = true;
  return sessionId;
};

export const getSessionIdSync = (): { id: string } | null => sessionId ?? null;

export const setSessionId = (id: { id: string }) => {
  sessionId = id;
  initialized = true;
};
